<app-temp-modal-cadastro #modalCadastro (closed)="onClose()" [textHeader]="textHeader" modalContentId="modal-veiculo"
  [customClass]="'modal-lg'">
  <app-veiculo-cadastro-form #veiculoForm [modal]="true" (salvar)="onSalvar($event)" (cancelar)="onCancelar()"></app-veiculo-cadastro-form>
</app-temp-modal-cadastro>